import { useGetMatchInfo } from "@/api/services/main/match";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { MatchDetail } from "@/features/match/components/MatchDetail";
import { convertMatchRes } from "@/features/match/utils/convertMatch";

export const MatchPage = () => {
  const { data, isLoading } = useGetMatchInfo();

  if (isLoading) return <LoadingPage />;

  return <MatchDetail previousValues={convertMatchRes(data?.data)} />;
};
